export default __webpack_public_path__ + "static/media/P_20201007_091328.f880b806.jpg";